import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'customer-spaces/:customerSpaceId/documents',
    loadChildren: () => import('@apps/documents/document.module').then((m) => m.DocumentModule),
  },
  {
    path: 'customer-spaces/:customerSpaceId/projects',
    loadChildren: () => import('@apps/projects/projects.module').then((m) => m.ProjectsModule),
  },
  {
    path: 'customer-spaces/:customerSpaceId/file-process',
    loadChildren: () => import('@apps/file-process/file-process.module').then((m) => m.ProcessModule),
  },
  {
    path: 'customer-spaces/:customerSpaceId/fiduciary',
    loadChildren: () => import('@apps/fiduciary/fiduciary.module').then((m) => m.FiduciaryModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AppsRoutingModule {}
